"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenSharingStream = getScreenSharingStream;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _logger = require("@studio/logger");
var _constants = require("@studio/constants");
var loggerName = 'ScreenShare-Helper';
/**
 * This method will log the shared display surface and returns media stream to handle screen sharing.
 * @returns the media stream, the type of screen share and if audio is included in the stream.
 */
function getScreenSharingStream() {
  return _getScreenSharingStream.apply(this, arguments);
}
function _getScreenSharingStream() {
  _getScreenSharingStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var stream, hasAudio, settings, shareType;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return navigator.mediaDevices.getDisplayMedia({
            video: true,
            audio: true
          });
        case 3:
          stream = _context.sent;
          hasAudio = stream.getAudioTracks().length > 0;
          settings = stream.getVideoTracks()[0].getSettings();
          (0, _logger.sendToDatadog)(loggerName, {
            streamSettings: settings
          }, 'Screen share stream settings.', false);

          // Edge case: The stream exists but is blank, screen share failed for an unknown reason
          if (!(!settings.width || !settings.height || settings.width === 0 || settings.height === 0)) {
            _context.next = 10;
            break;
          }
          stopTracks(stream);
          throw new Error('Unable to start a screenshare.');
        case 10:
          shareType = _constants.DISPLAY_SURFACE_TYPES[settings.displaySurface] || settings.displaySurface;
          console.log("User chose to share: ".concat(shareType).concat(hasAudio ? ' with audio.' : ' without audio.'));
          (0, _logger.sendToDatadog)(loggerName, {
            shareType: shareType,
            hasAudio: hasAudio
          }, "User shared ".concat(shareType).concat(hasAudio ? ' with audio.' : ' without audio.'), false);
          return _context.abrupt("return", {
            stream: stream,
            hasAudio: hasAudio,
            shareType: shareType
          });
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](0);
          (0, _logger.sendToDatadog)(loggerName, {
            error: _context.t0
          }, "Error while creating screen sharing stream.", true);
          throw _context.t0;
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 16]]);
  }));
  return _getScreenSharingStream.apply(this, arguments);
}
var stopTracks = function stopTracks(stream) {
  stream.getTracks().forEach(function (track) {
    return track.stop();
  });
};